import { Component, inject, OnInit, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map, first, mergeMap } from 'rxjs/operators';
import { CandidateQuestionDto } from '../../../../model/exam/candidate-question-dto';
import { QuestionStateDto } from '../../../../model/exam/state/question-state-dto';
import { ExamNavigationService } from '../../../../service/exam-navigation.service';
import { CandidateQuestionDataService } from '../../../../database/services/candidate-question-data.service';
import { TimeService } from '../../../../service/time.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDivider } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-section-modal',
    templateUrl: './section-modal.component.html',
    styleUrls: ['./section-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDivider, MatButton, MatDialogActions]
})
export class SectionModalComponent implements OnInit {
	public questions!: { flagged: CandidateQuestionDto[], nonAttempted: CandidateQuestionDto[] };

	public readonly canReturn: WritableSignal<boolean> = signal(false);

	private readonly router: Router = inject(Router);
	private readonly candidateQuestionDataService: CandidateQuestionDataService = inject(CandidateQuestionDataService);
	private readonly timeService: TimeService = inject(TimeService);
	private readonly dialogRef: MatDialogRef<SectionModalComponent> = inject(MatDialogRef);
	private readonly examNavigationService: ExamNavigationService = inject(ExamNavigationService);

	public ngOnInit(): void {

		const flaggedQuestions: Observable<CandidateQuestionDto[]> = this.candidateQuestionDataService.getCurrentSectionFlaggedQuestions();
		const nonAttemptedQuestions: Observable<CandidateQuestionDto[]> = this.candidateQuestionDataService.getCurrentSectionNonAttemptedQuestions();

		forkJoin({
			flagged: flaggedQuestions,
			nonAttempted: nonAttemptedQuestions
		})
		.pipe(map((questions: { flagged: CandidateQuestionDto[], nonAttempted: CandidateQuestionDto[] }) => {
			this.questions = questions;
		}))
		.subscribe();

		this.examNavigationService.getCanRevisitSections()
			.pipe(first())
			.subscribe((canRevisit: boolean) => this.canReturn.set(canRevisit));
	}

	public close(): void {
		this.dialogRef.close();
	}

	public navigateSection(): void {
		this.close();
		this.timeService.nextBlock().subscribe((url: string) => {
			if (url) {
				this.router.navigate([url]);
			}
		});
	}

	public goToQuestion(questionNumber: number): void {
		this.candidateQuestionDataService.getQuestion(questionNumber)
		.pipe(mergeMap((questionState: QuestionStateDto) => this.examNavigationService.updateCurrentQuestion(questionState))).subscribe(() => {
			this.close();
		});
	}
}
